import { PageLayout } from '@/layouts/page-layout'
import { useTranslation } from 'react-i18next'
import { Await, Link, Outlet, useLoaderData } from 'react-router-dom'
import { Suspense, useEffect } from 'react'
import {
  CreateButton,
  DownloadButton,
  MassiveUploadButton
} from '@/shared/components/action-buttons'
import { LinkWithQuery } from '@/shared/components/link-with-query'
import { create } from '@/router/utils'
import { HasAccess } from '@permify/react-role'
import { useAuthorization } from '@/hooks'
import { AssetTable } from './tables'
import { PageLayoutError, PageLayoutOverlay } from '@/layouts'
import { AssetFilter } from '@/components/asset-filter'

export const AssetList = () => {
  const { promise } = useLoaderData()
  const { t } = useTranslation()
  const { hasAccess } = useAuthorization({
    redirection: {
      enable: true
    }
  })

  useEffect(() => {
    hasAccess('asset#list')
  }, [])

  return (
    <PageLayout
      title={t('asset.other')}
      actions={
        <div key='asset-action-buttons' className='flex gap gap-3'>
          <AssetFilter />
          <Link to={'import'}>
            <MassiveUploadButton />
          </Link>
          <LinkWithQuery to='reports'>
            <DownloadButton />
          </LinkWithQuery>
          <HasAccess permissions={['asset#create']}>
            <Link key='new_company' to={create('assets')}>
              <CreateButton />
            </Link>
          </HasAccess>
        </div>
      }
    >
      <Outlet />
      <Suspense fallback={<PageLayoutOverlay />}>
        <Await resolve={promise} errorElement={<PageLayoutError />}>
          <AssetTable />
        </Await>
      </Suspense>
    </PageLayout>
  )
}
